module.exports = __webpack_public_path__ + "static/media/provozovna (2).496a0f88.png";